<i18n>
{
  "en": {
    "label": {
      "confirmButton": "Confirm",
      "dateTimePickerButton": "Set DateTime",
      "backButton": "Back",
      "submitButton": "Submit"
    },
    "message": {
      "pleaseInput": "Please enter the additional information required for the award.",
      "expire": "The entry deadline is up to {limitDate}.",
      "shipping": "If you do not enter your shipping information, shipping will be canceled.",
      "published": "If you do not enter the display information, it will be posted blank when displaying works or sites.",
      "complete": "Completed",
      "award": "see below",
      "notice": "Notice from the secretariat",
      "placeholderPostCode": "Please use 7 half-width characters without hyphens",
      "hintPostCode": "Please use 7 half-width characters without hyphens (e.g. 1000004)",
      "placeholderTelNumber": "Please use 10 or 11 single-byte numbers without hyphens",
      "hintTelNumber": "Please use 10 or 11 single-byte numbers without hyphens. (e.g. 0312345678)",
      "placeholderPrefecture": "Please select",
      "placeholderAddress": "Please fill in the city or town",
      "hintAddress": "Please fill in the city or town (e.g., 2-3-1 Kasumigaseki, Chiyoda-ku, Tokyo)",
      "placeholderName": "Please enter the name of the prize shipping address",
      "hintName": "Please enter the name of the prize shipping address",
      "placeholderText1": "Please enter between ",
      "placeholderText2": " and ",
      "placeholderText3": " characters",
      "shootingPositionText1": "(This is not the location of the subject, but the location/area where you were standing when the photo was taken.)",
      "shootingPositionText2": "Pliease click shooting position in map",
      "shootingPositionNotice": "As stated in the Application Guidelines that you agreed to when submitting your entry to this contest, we ask that all winners submit the location information of their works for publication in the system that displays the winners' names, photos, and location information. However, if you are unable to submit location information due to unavoidable circumstances, please contact us at campaign@tokyocameraclub.com with the details of the circumstances. The secretariat will review the information after confirming the details.",
      "shootingPositionTermTitle": "Confirmation of information regarding filming locations and times",
      "shootingPositionTerm": "As stated in the “Contest Rules” that you agreed to when entering this contest, entrants agree that Tokyo Camera Club Co., Ltd. (including third parties authorized by Tokyo Camera Club Co., Ltd., hereinafter the same) may use, publish, reprint, publicly transmit, etc. the submitted works free of charge and indefinitely for the purpose of PR for Tokyo Camera Club Co., Ltd. Regarding submitted works, we may use them in the same manner as described above after obtaining prior consent from the photographer. Additionally, applicants agree not to assert any rights based on moral rights of authorship against Tokyo Camera Club Co., Ltd. This also applies to submitted works for which location and time information has been provided.",
      "shootingDate": "Please click shooting date button",
      "shootingPositionErrorMessage": "Please enter shooting position required.",
      "shootingDateErrorMessage": "Please enter shooting date required.",
      "inputErrorMessage": "There is an input error. Please refer to the message displayed in the input item and correct the content.",
      "requestInputErrorMessage": "There is an input error. Please refer to the message displayed below and correct the content."
    }
  },
  "ja": {
    "label": {
      "confirmButton": "登録確認画面へ",
      "dateTimePickerButton": "日時選択",
      "backButton": "戻る",
      "submitButton": "上記内容で登録する"
    },
    "message": {
      "pleaseInput": "つきましては、受賞にあたり必要な追加情報の入力をお願いいたします。",
      "expire": "入力期限は {limitDate} です",
      "shipping": "※期限までにご入力いただけなかった場合、賞品の授与は見送りとさせていただきます。(受賞自体は無効となりません。)",
      "published": "※期限までにご入力いただけなかった場合、サイト掲載や作品展示がある場合は空欄のまま掲載させていただきます。(受賞自体は無効となりません。)",
      "complete": "入力いただいたデータを確認中です。もうしばらくお待ち下さい。",
      "award": "あなたは下記に確定いたしました。(※こちらからご連絡するまで、受賞の公表はしないようお願いいたします)",
      "notice": "事務局からのお知らせ",
      "placeholderPostCode": "ハイフンなし半角7桁でご記入ください",
      "hintPostCode": "ハイフンなし半角7桁でご記入ください(例：1000004)",
      "placeholderTelNumber": "ハイフンなし10桁または、11桁の半角数字で入力ください",
      "hintTelNumber": "ハイフンなし10桁または、11桁の半角数字で入力ください(例：0312345678)",
      "placeholderPrefecture": "選択してください",
      "placeholderAddress": "市区町村以降をご記入ください",
      "hintAddress": "市区町村以降をご記入ください(例：千代田区霞が関2-3-1)",
      "placeholderName": "賞品発送先のお名前を入力してください",
      "hintName": "賞品発送先のお名前を入力してください",
      "placeholderText1": " ",
      "placeholderText2": " 文字以上 ",
      "placeholderText3": " 文字以内で入力してください（※改行はできません。）",
      "shootingPositionText1": "(※被写体のある場所ではなく、撮影時に立っていた場所・エリアです)",
      "shootingPositionText2": "※撮影場所を地図上でクリックして指定してください。地名・建物等で検索することも可能です。",
      "shootingPositionNotice": "※本コンテストご応募時に同意いただいております「募集要項」にも記載の通り、受賞者の皆さまには「受賞者名と写真と撮影地情報を表示するシステム」への掲載のため、作品の撮影地情報等をご提出いただいております。ただし、やむを得ない事由が発生して撮影地情報等を掲載できないことになってしまった方につきましては、発生した事由を添えて当事務局メールアドレス「campaign@tokyocameraclub.com」宛てにご相談ください。事務局にて内容を確認のうえ、検討させていただきます。",
      "shootingPositionTermTitle": "撮影場所および撮影時間情報提供に関する確認事項",
      "shootingPositionTerm": "※本コンテストご応募時に同意いただいております「募集要項」にも記載の通り、応募者は、東京カメラ部株式会社のPR用などに使用する目的で東京カメラ部株式会社（東京カメラ部株式会社が許可した第三者を含むものとし、以下同じとします。）が、無償かつ無期限に使用、掲載、転載、公衆送信等することを承諾するものとします。応募作品については、撮影者に事前に許諾確認の上、上記同様使用することがございます。また、応募者は、東京カメラ部株式会社に対し、著作者人格権に基づく権利の主張を一切行わないものとします。撮影場所および撮影時間情報をご提供いただいた応募作品につきましても、同様とさせていただきます。",
      "shootingDate": "「日時選択」ボタンを押して撮影日時を登録してください。",
      "shootingPositionErrorMessage": "撮影場所情報が入力されていません。",
      "shootingDateErrorMessage": "撮影日時が入力されていません。",
      "inputErrorMessage": "入力エラーがあります。入力項目に表示されているメッセージを参照の上、内容の修正をお願いします。",
      "requestInputErrorMessage": "入力エラーがあります。下記に表示されているメッセージを参照の上、内容の修正をお願いします。"
    }
  }
}
</i18n>

<template>
  <div>
    <div
      class="message-area"
      v-show="this.formStatus != this.FORM_STATUS_COMPLETE"
    >
      <div>{{ $t('message.award') }}</div>
      <div class="award-area"><span style="font-size: 1.5rem;">{{ this.awardName }}</span></div>
      <div v-if="isShipping">{{ $t('message.pleaseInput') }}</div>
      <div class="expire-area">
        {{ $t('message.expire', { limitDate: limitDate }) }}
        <a :href="'/cp/' + getCampaignCode() + '/me/help#category4'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
      </div>
      <div v-if="isShipping">{{ $t('message.shipping') }}</div>
      <div v-if="isPublished">{{ $t('message.published') }}</div>

      <v-card
        v-if="this.work.attachedAnswersComment"
        style="margin-top: 16px; margin-bottom: 16px; padding: 16px;"
      >
        <div
          v-if="this.work.attachedAnswersComment"
          style="font-weight: bold; margin-bottom: 16px; color: red;"
        >
          {{ $t('message.notice') }}
        </div>
        <span style="white-space: pre-wrap;">{{
          this.work.attachedAnswersComment
        }}</span>
      </v-card>

    </div>
    <div class="form-area">
      <div v-show="this.formStatus == this.FORM_STATUS_INPUT" id="inputForm">
        <form @submit.prevent="confirm">
          <div v-for="(item, index) in this.formItems" :key="item.id">
            <div
              v-if="
                item.validationType ==
                  EnumAttachedItems.ValidationType.Prefecture
              "
            >
              <span class="font-weight-bold">{{ item.displayName }}</span>
              <small v-if="item.notes"><br />{{ item.notes }}</small>
              <p
                class="vee-error"
                style="color: #F87060"
                v-if="errors.first(item.name)"
              >
                {{ errors.first(item.name) }}
              </p>
              <v-combobox
                :items="prefectureItems"
                label=""
                :name="item.name"
                v-validate="item.validation"
                v-model="item.value"
                :data-vv-as="item.displayName"
                background-color="white"
                :placeholder="'  ' + item.placeholder"
              ></v-combobox>
            </div>

            <div
              v-else-if="
                item.validationType == EnumAttachedItems.ValidationType.TextArea
              "
            >
              <span class="font-weight-bold">{{ item.displayName }}</span>
              <small v-if="item.notes"><br />{{ item.notes }}</small>
              <p
                class="vee-error"
                style="color: #F87060"
                v-if="errors.first(item.name)"
              >
                {{ errors.first(item.name) }}
              </p>
              <TextAreaInput
                :name="item.name"
                v-validate="item.validation"
                v-model="item.value"
                :data-vv-as="item.displayName"
                :placeholderValue="item.placeholder"
              >
              </TextAreaInput>
            </div>

            <div
              v-else-if="
                item.validationType == EnumAttachedItems.ValidationType.ShootingPosition
              "
              style="margin-bottom: 16px;"
            >
              <!-- <div v-if="index == firstShootingUiIndex">
                撮影場所情報関連の最初の表示の際には、必ず規約同意のチェックボックスを表示する
                <br /><b>＜撮影情報取得に関わる同意事項＞</b><br />
                以下の内容に同意する場合、チェックボックスをチェックして撮影情報を入力してください。同意しない場合、チェックをせず撮影情報は未入力のまま次へお進みください。（※受賞への影響等はありません。）<br />
                <div class="shooting-agree-area">
                  <v-checkbox
                    v-model="pssAgree"
                    @change="checkShootingAgree"
                    label="以下の規約に同意し、撮影場所および撮影時間情報を提供する。"
                  ></v-checkbox>
                  <div>
                    受賞者は、東京カメラ部株式会社（東京カメラ部株式会社が許可した第三者を含むものとし、以下同じとします。）が他社に提供する可能性がある「受賞者名と写真と撮影地情報を表示するシステム」に受賞者名と応募作品と撮影地情報を無償かつ無期限に使用、掲載、転載、公衆送信等することを承諾するものとします。また、受賞者は、東京カメラ部、及び東京カメラ部が許可した第三者に対し、本受賞作品に関する著作者人格権に基づく権利の主張を一切行わないものとします。
                  </div>
                </div>
              </div> -->
              <!-- 2025-08-01 10:23:09 以下に、著作者人格権に基づく権利の主張を一切行わないものとする規約を追加。本来は、この上部でコメントアウトされている規約文とチェックボックスがあったが、必須項目になったため、一旦削除されていた。今回新たに、文言だけ復活した状態で記載することとなった。 -->
              <span class="font-weight-bold">{{ $t('message.shootingPositionTermTitle') }}</span><br />
              <div style="margin-bottom: 16px;">
                <small>{{ $t('message.shootingPositionTerm') }}</small>
              </div>

              <span class="font-weight-bold">{{ item.displayName }}{{ $t('message.shootingPositionText1') }}</span><br />
              <small v-if="item.notes">{{ item.notes }}<br /></small>
              <small>{{ $t('message.shootingPositionText2') }}</small><br />
              <small>{{ $t('message.shootingPositionNotice') }}</small>
              <p
                class="vee-error"
                style="color: #F87060"
                v-if="item.errorMessage"
              >
                {{ item.errorMessage }}
              </p>
              <MapView v-model="item.value" :defaultValue="item.value" :disabled="!pssAgree"></MapView>
            </div>

            <div
              v-else-if="
                item.validationType == EnumAttachedItems.ValidationType.ShootingDate
              "
            >
              <!-- <div v-if="index == firstShootingUiIndex">
                撮影場所情報関連の最初の表示の際には、必ず規約同意のチェックボックスを表示する
                撮影場所情報取得に関わる同意事項<br />
                <br /><b>＜撮影情報取得に関わる同意事項＞</b><br />
                以下の内容に同意する場合、チェックボックスをチェックして撮影情報を入力してください。同意しない場合、チェックをせず撮影情報は未入力のまま次へお進みください。（※受賞への影響等はありません。）<br />
                <div class="shooting-agree-area">
                  <v-checkbox
                    v-model="pssAgree"
                    label="以下の規約に同意し、撮影場所および撮影時間情報を提供する。"
                  ></v-checkbox>
                  <div>
                  受賞者は、東京カメラ部株式会社（東京カメラ部株式会社が許可した第三者を含むものとし、以下同じとします。）が他社に提供する可能性がある「写真と撮影地情報を組み合わせた情報提供サービス」に応募作品と撮影地情報を無償かつ無期限に使用、掲載、転載、公衆送信等することを承諾するものとします。また、受賞者は、東京カメラ部、及び東京カメラ部が許可した第三者に対し、著作者人格権に基づく権利の主張を一切行わないものとします。
                  </div>
                </div>
              </div> -->

              <span class="font-weight-bold">{{ item.displayName }}</span>
              <small v-if="item.notes"><br />{{ item.notes }}</small><br />
              <p
                class="vee-error"
                style="color: #F87060"
                v-if="item.errorMessage"
              >
                {{ item.errorMessage }}<br />
              </p>
              <small>{{ $t('message.shootingDate') }}</small>
              <div style="display: flex; flex-direction: row; items-align: center; ">
                <div class="datetime-ui">
                  {{ displayDate(item.value) }}
                </div>
                <div>
                  <v-btn color="primary" id="dateTimePickerButton"
                    @click="openDateTimePickerDialog"
                    :disabled="!pssAgree"
                  >
                    {{ $t('label.dateTimePickerButton') }}
                  </v-btn>
                </div>
              </div>
              <DateTimePickerDialog
                :dialog="dateTimePickerDialog"
                @click="dateTimePickerDialogClickOkButton"
                @cancel="dateTimePickerDialogClickCancelButton"
                v-model="item.value"
              ></DateTimePickerDialog>
            </div>

            <div v-else>
              <span class="font-weight-bold">{{ item.displayName }}</span>
              <small v-if="item.notes"><br />{{ item.notes }}</small>
              <p
                class="vee-error"
                style="color: #F87060"
                v-if="errors.first(item.name)"
              >
                {{ errors.first(item.name) }}
              </p>
              <TextInput
                :name="item.name"
                v-validate="item.validation"
                v-model="item.value"
                :data-vv-as="item.displayName"
                :placeholderValue="item.placeholder"
                :hint="item.hint"
              >
              </TextInput>
            </div>
          </div>

          <div v-if="errorMessage">
            <v-icon color="error">warning</v-icon>
            <span
              v-if="errorMessage"
              class="errorMessageArea"
              v-html="errorMessage"
            ></span>
          </div>
          <div style="margin-top: 24px;">
            <v-btn color="primary" type="submit" id="confirmButton">
              {{ $t('label.confirmButton') }}
            </v-btn>
          </div>
        </form>
        <br />&nbsp;
      </div>
      <div
        v-show="this.formStatus == this.FORM_STATUS_CONFIRM"
        id="confirmForm"
      >
        <div v-for="item in this.formItems" :key="item.id">
          <div
            v-if="
              item.validationType == EnumAttachedItems.ValidationType.TextArea
            "
          >
            {{ item.displayName }}<br />
            <v-card
              class="confirm-item"
              color="#fafafa"
              style="white-space: pre;"
              v-text="item.value"
            />
          </div>
          <div
            v-else-if="
                item.validationType == EnumAttachedItems.ValidationType.ShootingDate
            "
          >
            {{ item.displayName }}<br />
            <v-card class="confirm-item" color="#fafafa">
              {{ displayDate(item.value) }}
            </v-card>
          </div>
          <div v-else>
            {{ item.displayName }}<br />
            <v-card class="confirm-item" color="#fafafa">
              {{ item.value }}
            </v-card>
          </div>
        </div>

        <div
          v-if="errorMessage"
          class="errorMessageArea"
          v-html="errorMessage"
        ></div>

        <div style="margin-top: 24px;">
          <v-btn color="primary" type="button" @click="back()" id="backButton">
            {{ $t('label.backButton') }}
          </v-btn>
          <v-btn
            color="primary"
            type="button"
            @click="submit()"
            id="submitButton"
          >
            {{ $t('label.submitButton') }}
          </v-btn>
        </div>
        <br />&nbsp;
      </div>
      <div
        v-show="this.formStatus == this.FORM_STATUS_COMPLETE"
        id="completeForm"
      >
        <div style="padding-top: 20px; padding-left: 20;">
          {{ $t('message.complete') }}
        </div>
        <br />&nbsp;
      </div>
    </div>
  </div>
</template>

<script>
'use strict';
import TextInput from '@/components/atoms/TextInput.vue';
import TextAreaInput from '@/components/atoms/TextAreaInput.vue';
import { Me } from '@/api';
import { EnumAttachedItems } from '@/enum/enum.js';
import { dateFormatter } from '@/utils';
import StorageManager from '@/utils/StorageManager';
import MapView from '@/components/molecules/MapView';
import DateTimePickerDialog from '@/components/dialogs/DateTimePickerDialog';

export default {
  components: {
    TextInput,
    TextAreaInput,
    MapView,
    DateTimePickerDialog
  },
  props: {
    value: Object //work情報が入る。親コンポーネントからv-modelで指定されたprops
  },
  data() {
    return {
      EnumAttachedItems: EnumAttachedItems, //enum直を設定
      FORM_STATUS_INPUT: 'INPUT',
      FORM_STATUS_CONFIRM: 'CONFIRM',
      FORM_STATUS_COMPLETE: 'COMPLETE',
      prefectureItems: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県'
      ],
      formItems: [], //Formの入力項目情報を保持
      formStatus: '', //現在表示されているFormの状況
      work: {},
      limitDate: '',
      isShipping: false,
      isPublished: false,
      awardName: '',

      errorMessage: '',

      dateTimePickerDialog: false,

      firstShootingUiIndex: -1,

      pssAgree: true
    };
  },
  methods: {
    checkShootingAgree() {
      for (let item of this.formItems) {
        if (item.validationType == this.EnumAttachedItems.ValidationType.ShootingPosition ||
            item.validationType == this.EnumAttachedItems.ValidationType.ShootingDate) {
          if (!this.pssAgree) {
            //チェックが外された場合、入力内容をクリアする
            item.value = '';
          }
        }
      }
    },
    displayDate(dt) {
      if (!dt) return;
      return dateFormatter.formatWithLocale(dt);
    },
    openDateTimePickerDialog() {
      this.dateTimePickerDialog = true;
    },
    dateTimePickerDialogClickOkButton(text) {
      this.dateTimePickerDialog = false;
    },
    dateTimePickerDialogClickCancelButton() {
      this.dateTimePickerDialog = false;
    },
    confirm() {
      //位置情報のチェック
      let isError = false;
      for (let item of this.formItems) {
        if (this.pssAgree) {
          if (item.validationType == this.EnumAttachedItems.ValidationType.ShootingPosition) {
            if (!item.value) {
              item.errorMessage = this.$t('message.shootingPositionErrorMessage');
              isError = true;
            } else {
              item.errorMessage = '';
            }
          } else if (item.validationType == this.EnumAttachedItems.ValidationType.ShootingDate) {
            if (!item.value) {
              item.errorMessage = this.$t('message.shootingDateErrorMessage');
              isError = true;
            } else {
              item.errorMessage = '';
            }
          }
        }
      }

      this.$validator.validate().then(result => {
        if (result) {
          if (isError) {
            // 入力エラーがある場合は、ボタン上のエラーメッセージ表示エリアに、エラー発生を通知する
            this.errorMessage = this.$t('message.inputErrorMessage');
            return;
          }

          this.formStatus = this.FORM_STATUS_CONFIRM;

          //エラーの全体メッセージはこの段階でクリア
          this.errorMessage = '';
        } else {
          // 入力エラーがある場合は、ボタン上のエラーメッセージ表示エリアに、エラー発生を通知する
          this.errorMessage = this.$t('message.inputErrorMessage');
        }
      });
    },
    back() {
      this.formStatus = this.FORM_STATUS_INPUT;
    },
    /**
     * 追加情報登録処理
     */
    submit() {
      //POST用データの生成
      const form = {
        attachedAnswers: []
      };
      let patchFlag = false;
      for (let item of this.formItems) {
        const answer = {};
        if (item.id) {
          answer.id = item.id;
          patchFlag = true;
        }
        answer.attachedItemId = item.attachedItemId;
        answer.answer = item.value;
        form.attachedAnswers.push(answer);
      }
      if (patchFlag) {
        //PATCH(更新)
        Me.patchAttachedAnswers(this.work.id, form)
          .then(() => {
            this.formStatus = this.FORM_STATUS_COMPLETE;

            //画面表示の書き換えが大変なので、強制リロードすることとした
            window.location.reload();
          })
          .catch(error => {
            //エラーが発生した場合、画面にエラーを表示する
            //なお、この段階で発生したエラーは、画面下部に一覧形式で表示することとする
            if (error.errors.length > 0) {
              this.errorMessage = this.errorMessage = this.$t('message.requestInputErrorMessage');;
              for (let errorItem of error.errors) {
                this.errorMessage += `<br />${errorItem.code}`;
              }

              //エラーが発生したので、確認画面から入力画面へ遷移する
              this.formStatus = this.FORM_STATUS_INPUT;
            }
          });
      } else {
        //POST(新規登録)
        Me.postAttachedAnswers(this.work.id, form)
          .then(() => {
            this.formStatus = this.FORM_STATUS_COMPLETE;

            //画面表示の書き換えが大変なので、強制リロードすることとした
            window.location.reload();
          })
          .catch(error => {
            //エラーが発生した場合、画面にエラーを表示する
            //なお、この段階で発生したエラーは、画面上部に一覧形式で表示することとする
            if (error.errors.length > 0) {
              this.errorMessage = this.errorMessage = this.$t('message.requestInputErrorMessage');;
              for (let errorItem of error.errors) {
                this.errorMessage += `<br />${errorItem.code}`;
              }

              //エラーが発生したので、確認画面から入力画面へ遷移する
              this.formStatus = this.FORM_STATUS_INPUT;
            }
          });
      }
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  beforeMount: function() {
    //親でv-modelされたvalue値を設定
    this.work = this.value;
    //フォームの初期値を設定
    this.formStatus = this.FORM_STATUS_INPUT;
    //期限日の設定
    this.limitDate = dateFormatter.formatWithLocale(
      this.work.statusUpdateDueTo
    );

    //賞情報を取得
    if (this.work.awardId) {
      Me.fetchAwards(this.work.awardId, 'attached_items').then(async data => {
        //賞情報を設定
        this.awardName = data.name;

        //APIから取得した情報を元に、フォーム表示用オブジェクトの生成を開始
        if (!data.attachedItems) return;
        //関連する回答情報が既に登録されているかをチェック
        const attachedAnswersHash = {};
        await Me.fetchAttachedAnswers(this.work.id).then(result => {
          for (let attachedAnswer of result.data.attachedAnswers) {
            attachedAnswersHash[attachedAnswer.attachedItemId] = attachedAnswer; //回答情報をあとで参照するように設定
          }
        });
        //フォーム表示用オブジェクト生成
        let shootingPositionFulfillFalg = true;
        let index = 0;
        for (let attachedItem of data.attachedItems) {
          const item = {};
          let attachedAnswer = attachedAnswersHash[attachedItem.id];
          item.id =
            attachedAnswer && attachedAnswer.id ? attachedAnswer.id : null;
          item.attachedItemId = attachedItem.id;
          item.value =
            attachedAnswer && attachedAnswer.answer
              ? attachedAnswer.answer
              : '';
          item.displayName = attachedItem.name;
          item.name = `item-${attachedItem.id}`;
          item.validationType = attachedItem.validationType;
          item.notes = attachedItem.notes;
          item.validation = {};
          if (attachedItem.required) {
            item.validation.required = true;
          }
          if (attachedItem.minChar) {
            item.validation.min = attachedItem.minChar;
          }
          if (attachedItem.maxChar) {
            item.validation.max = attachedItem.maxChar;
          }
          if (attachedItem.validationType == EnumAttachedItems.ValidationType.PostCodeJp) {
            item.placeholder = this.$t('message.placeholderPostCode');
            item.hint = this.$t('message.hintPostCode');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.Prefecture) {
            item.placeholder = this.$t('message.placeholderPrefecture');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.Address) {
            item.placeholder = this.$t('message.placeholderAddress');
            item.hint = this.$t('message.hintAddress');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.Name) {
            item.placeholder = this.$t('message.placeholderName');
            item.hint = this.$t('message.hintName');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.TelNumberJp) {
            item.placeholder = this.$t('message.placeholderTelNumber');
            item.hint = this.$t('message.hintTelNumber');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.Text) {
            item.placeholder = this.$t('message.placeholderText1') + attachedItem.minChar + this.$t('message.placeholderText2') + attachedItem.maxChar + this.$t('message.placeholderText3');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.TextArea) {
            item.placeholder = this.$t('message.placeholderText1') + attachedItem.minChar + this.$t('message.placeholderText2') + attachedItem.maxChar + this.$t('message.placeholderText3');
          } else if (attachedItem.validationType == EnumAttachedItems.ValidationType.DisplayName) {
            item.placeholder = this.$t('message.placeholderText1') + attachedItem.minChar + this.$t('message.placeholderText2') + attachedItem.maxChar + this.$t('message.placeholderText3');
          }
          this.formItems.push(item);

          //最初の撮影場所UIの位置を記録する
          if (this.firstShootingUiIndex < 0 && (
            attachedItem.validationType == this.EnumAttachedItems.ValidationType.ShootingPosition ||
            attachedItem.validationType == this.EnumAttachedItems.ValidationType.ShootingDate)) {
            this.firstShootingUiIndex = index;
          }

          //撮影場所情報が全て入力ずみかどうかをチェックする
          if (!item.value && (attachedItem.validationType == this.EnumAttachedItems.ValidationType.ShootingPosition ||
            attachedItem.validationType == this.EnumAttachedItems.ValidationType.ShootingDate)) {
            shootingPositionFulfillFalg = false;
          }

          //表示メッセージの設定
          if (attachedItem.purpose == '1') {
            //入力画面で、1が1つでもあったら公開情報の注意事項を表示
            this.isPublished = true;
          } else if (attachedItem.purpose == '2') {
            //入力画面で、2が1つでもあったら配送情報の注意事項を表示
            this.isShipping = true;
          }

          index++;
        }
        //撮影場所情報が全て入力されていたら、チェックボックスにチェックされていたことになるので、
        //ここでチェックを設定する
        if (shootingPositionFulfillFalg) {
          this.pssAgree = true;
        }
      });
    }
  }
};
</script>

<style scoped lang="stylus">
div.v-input__slot {
  border-radius: 4px !important;
}

.message-area {
  padding: 16px 16px;
}

.errorMessageArea {
  color: red;
  margin-bottom: 32px;
}

.award-area {
  font-weight: bold;
  padding: 2px 16px;
}

.expire-area {
  font-weight: bold;
  color: red;
}

.form-area {
  margin: 16px; 32px;
  padding: 0px;
}

.confirm-item {
  margin: 4px 0px 24px 0px;
  padding: 8px 10px;
}

.vee-error {
  color: red;
  margin: 0px;
}

.shooting-agree-area {
  padding: 8px;
  padding-bottom: 24px;
  margin-bottom: 20px;
  display: flex;
  flex-direction column;
  border: solid 1px #cccccc;
  border-radius: 6px;
  background-color: #ffffff;
}

.datetime-ui {
  padding: 8px;
  width: 200px;
  display: flex;
  flex-direction row;
  align-items: center;
  border: solid 1px #cccccc;
  border-radius: 6px;
  background-color: #ffffff;
}
</style>
